export default __webpack_public_path__ + "static/media/001-snowboard.82055943.svg";